<template>
  <div class="wechat_ad_behavior">
    <div class="row actions" v-if="behaviorType.include">
      <h3>再营销</h3>
      <el-checkbox-group v-model="form.actions" @change="onBehaviorChange">
        <el-checkbox v-for="item in WECHAT_AD_BEHAVIORS_LIST" :disabled="actionsDisabled(item.value)" :label="item.value" :key="item.value">
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>
    <div class="row excluded-actions" v-if="behaviorType.exclude">
      <h3>排除营销</h3>
      <el-checkbox-group v-model="form.excluded_actions" @change="onBehaviorChange">
        <el-checkbox
          v-for="item in WECHAT_AD_BEHAVIORS_LIST"
          :disabled="excludedActionsDisabled(item.value)"
          :label="item.value"
          :key="item.value"
        >
          {{ item.label }}
        </el-checkbox>
      </el-checkbox-group>
    </div>

    <div
      style="margin-top: 10px"
      v-if="form.actions.includes('MINI_GAME_WECHAT_REGISTERED') || form.excluded_actions.includes('MINI_GAME_WECHAT_REGISTERED')"
    >
      <span style="font-weight: 700">已注册用户活跃度：</span>
      <el-select v-model="form.mini_game_wechat_registered_activity">
        <el-option v-for="item in WECHAT_AD_BEHAVIORS_REGISTERED_ACTIVITY" :key="item.label" :value="item.value" :label="item.label">
        </el-option>
      </el-select>

      <el-tooltip effect="dark" content="通过是否再次进入小游戏来判定活跃度" placement="top">
        <em class="el-icon-warning" style="margin-left: 10px"></em>
      </el-tooltip>
    </div>
  </div>
</template>
<script>
import { WECHAT_AD_BEHAVIORS_LIST, WECHAT_AD_BEHAVIORS_REGISTERED_ACTIVITY } from '../../../model/targeting-const'

export default {
  props: ['behavior', 'type'],
  data() {
    return { WECHAT_AD_BEHAVIORS_LIST, WECHAT_AD_BEHAVIORS_REGISTERED_ACTIVITY, form: this.behavior }
  },
  watch: {
    behavior(v) {
      this.form = v
    }
  },
  computed: {
    behaviorType() {
      return {
        include: this.type.includes('ACTIONS'),
        exclude: this.type.includes('EXCLUDED_ACTIONS')
      }
    }
  },
  methods: {
    /**
     * @description: 包含与排除不能有交集
     */
    actionsDisabled(value) {
      return this.behavior.excluded_actions.includes(value) && this.behaviorType.exclude
    },
    excludedActionsDisabled(value) {
      return this.behavior.actions.includes(value) && this.behaviorType.include
    },
    onBehaviorChange() {
      this.$emit('update:form', this.form)
    }
  }
}
</script>
<style lang="scss" scoped>
.wechat_ad_behavior {
  .row {
    margin-top: 15px;
    ::v-deep .el-checkbox__label {
      font-size: 12px;
    }
  }
  h3 {
    font-size: 12px;
  }
}
</style>
